import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  justify?: 'center' | 'start'
}

const ButtonList = ({ children, justify = 'center' }: Props) => {
  return (
    <>
      <div className={clsx('flex gap-x-2', `justify-${justify}`)}>{children}</div>
    </>
  )
}

export default ButtonList
